export default __webpack_public_path__ + "static/assets/82ee7975fab470338a60ceab1671eb3d.png";